var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isSupportedLanguage)?_c('cookies-dialog',{ref:"cookieselection",attrs:{"visible":"no","title":"Cookie Policy","withbanner":"yes"},domProps:{"innerHTML":_vm._s(_vm.template)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }